import { HttpErrorResponse } from '@angular/common/http';
import { ITag } from '@interfaces';
import { EMPTY } from '@utils';
import { ICompany } from '@company/company.structures';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ITagDialogParams } from '@module/company-module/workbook-option/workbook-option.component';
import { FormControlService } from '@base/form-controls.service';
import { TagService } from '@tag/tag.service';
import { Subscription } from 'rxjs';

export class Tag implements ITag {
  id = 0;
  name = '';
  company_id = 0;

  constructor(values: Object = {}) {
      Object.assign(this, values);
  }
}

@Component({
  templateUrl: './tag-dialog.component.html',
  styleUrls: ['./tag-dialog.component.sass']
})
export class TagDialogComponent implements OnInit, OnDestroy {
  private _edit = false;
  private _tag: ITag;

  company: ICompany;
  name = new FormControl(null, [Validators.required,
    Validators.minLength(3), Validators.maxLength(25)]);
  companyId = new FormControl(null, [Validators.required]);
  workbookId = new FormControl(null, [Validators.required]);
  dialogForm: FormGroup;
  showSpinner: boolean;

  constructor(
    public dialogRef: MatDialogRef<TagDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public info: ITagDialogParams,
    private fb: FormBuilder,
    private tagService: TagService,
    private formControlService: FormControlService,
    private snackBar: MatSnackBar,
  ) {
    this.showSpinner = false;
    if (info.tag === EMPTY) {
      info.tag = new Tag();
    }
    this.dialogForm = this.fb.group({
      name: this.name,
      companyId: this.companyId,
      workbookId: this.workbookId,
    });
    this.company = info.company;
  }

  ngOnInit() {
    this._tag = this.info['tag'];
    this._edit = this.info['edit'];

    this.dialogForm.patchValue({
      companyId: this.info.companyId,
      workbookId: this.info.workbook.id,
    });

    if (this._edit) {
      this.name.setValue(this.info.tag.name);
    } else {
      this.name.setValue('');
    }
  }

  ngOnDestroy() { }

  private sendResponse(tag: ITag) {
    this.showSpinner = false;
    this.dialogForm.reset();
    this.dialogRef.close(tag);
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 2000,
    });
  }

  onSubmit() {
    let auxTag: ITag = null;
    this.showSpinner = true;
    auxTag = (!this._edit) ? new Tag(this.dialogForm.value) : { ...this._tag, ...this.dialogForm.value, };
    const obs = (!this._edit) ? this.tagService.createTag(auxTag) : this.tagService.updateTag(auxTag);

    const subs: Subscription = obs.subscribe(
      (res: ITag) => {this.sendResponse(res); },
      (e: HttpErrorResponse) => {
        if (e.status === 409) {
          this.openSnackBar(`Etiqueta ${auxTag.name} ya existe`, 'info');
          this.showSpinner = false;
        } else {
          this.openSnackBar(`No se pudo registrar la Etiqueta.`, 'info');
        }
        this.dialogRef.close(EMPTY);
      }
    );
  }
}
